<template>
    <el-config-provider :locale="locale">
<!--      <router-view :key="$route.fullPath"></router-view>-->
      <router-view></router-view>
      <!-- 全局登录弹窗 -->
      <login_modal :is-visible="showLoginModal"></login_modal>
    </el-config-provider>
</template>

<script>
import {ElConfigProvider} from 'element-plus'
import zhCn from 'element-plus/lib/locale/lang/zh-cn'
import login_modal from "./components/login_modal";
import {mapState} from 'vuex'

export default {
  name: 'App',
  components: {login_modal, ElConfigProvider},
  computed: {
    ...mapState(['showLoginModal','showBaiLianModal'])
  },
  data() {
    return {
      locale: zhCn,
    }
  },
  mounted() {

  },
  methods: {
    //登录弹框
    showLogin() {
      this.$store.dispatch('toggleLoginModal');
    }

  }
}
</script>

<style lang="scss">
@use "assets/css/reset.scss";
@use "assets/css/admin.scss";
@use 'assets/css/common.scss';
//引入图标库及通用样式
@import 'assets/iconfont/iconfont.css';
.this-box{
  height: 100%;  // 不必是100vh，只需要是该容器显示的最大高度即可
  overflow-x: hidden;
}

/* 自定义滚动条样式 - 滚动时才显示 */
* {
  scrollbar-width: thin;
  scrollbar-color: transparent transparent;
  transition: scrollbar-color 0.3s ease;
}

*:hover {
  scrollbar-color: rgba(0, 0, 0, 0.3) transparent;
}

/* Webkit浏览器（Chrome, Safari, Edge）滚动条样式 */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: transparent;
}

::-webkit-scrollbar-thumb {
  background: transparent;
  border-radius: 4px;
  transition: background 0.3s ease;
}

*:hover::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.3);
}

*:hover::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.5);
}

/* 滚动时显示滚动条 */
html {
  overflow-y: auto;
  overflow-x: hidden;
}

body {
  overflow-x: hidden;
}
</style>
